// ViewBookingSkeleton.jsx — traces the head / ticket / sidebar grid of
// viewBooking.js so the page doesn't reflow when the real data lands.
//
// Shape classes use the page-unique sf-skel-vb-* prefix: the generic
// sf-skel-row / sf-skel-line names are declared by several other skeletons
// in this app with different values, and those declarations leak globally.
import React from "react";
import "./viewBookingSkeleton.css";

const ViewBookingSkeleton = () => {
	return (
		<div className="sf-skel-booking">
			<div className="sf-skel-vb-grid">
				{/* HEAD — spans both columns, as in viewBooking.css */}
				<div className="sf-skel-vb-head">
					<div className="sf-skel-vb-pill shimmer"></div>
					<div className="sf-skel-vb-eyebrow shimmer"></div>
					<div className="sf-skel-vb-line sf-skel-vb-title w-60 shimmer"></div>
					<div className="sf-skel-vb-pill shimmer"></div>
				</div>

				{/* ═══ MAIN ═══ */}
				<div className="sf-skel-vb-main">
					{/* TICKET */}
					<div className="sf-skel-vb-ticket">
						<div className="sf-skel-vb-ticket-top">
							<div className="sf-skel-vb-date shimmer"></div>

							<div className="sf-skel-vb-stack">
								<div className="sf-skel-vb-line sf-skel-vb-tiny w-30 shimmer"></div>
								<div className="sf-skel-vb-line sf-skel-vb-big w-70 shimmer"></div>
								<div className="sf-skel-vb-line sf-skel-vb-tiny w-50 shimmer"></div>
							</div>

							<div className="sf-skel-vb-staff">
								<div className="sf-skel-vb-circle shimmer"></div>
								<div className="sf-skel-vb-stack">
									<div className="sf-skel-vb-line sf-skel-vb-tiny w-50 shimmer"></div>
									<div className="sf-skel-vb-line w-80 shimmer"></div>
								</div>
							</div>
						</div>

						<div className="sf-skel-vb-perf"></div>

						<div className="sf-skel-vb-ticket-body">
							<div className="sf-skel-vb-line sf-skel-vb-tiny w-30 shimmer"></div>
							<div className="sf-skel-vb-services">
								{Array.from({ length: 2 }).map((_, i) => (
									<div className="sf-skel-vb-service" key={i}>
										<div className="sf-skel-vb-line w-50 shimmer"></div>
										<div className="sf-skel-vb-line w-30 shimmer"></div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>

				{/* ═══ SIDEBAR ═══ */}
				<div className="sf-skel-vb-sidebar">
					<div className="sf-skel-vb-card">
						<div className="sf-skel-vb-map shimmer"></div>
						<div className="sf-skel-vb-card-body">
							<div className="sf-skel-vb-line w-70 shimmer"></div>
							<div className="sf-skel-vb-btn shimmer"></div>
						</div>
					</div>

					<div className="sf-skel-vb-card sf-skel-vb-card-pad">
						<div className="sf-skel-vb-line sf-skel-vb-tiny w-50 shimmer"></div>
						<div className="sf-skel-vb-btn shimmer"></div>
						<div className="sf-skel-vb-btn shimmer"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ViewBookingSkeleton;
